module.exports = __webpack_public_path__ + "static/media/maleTwigs.7f6d70a0.svg";